import { render, staticRenderFns } from "./AutoMail.vue?vue&type=template&id=f9351fbc&scoped=true&lang=pug&"
import script from "./AutoMail.vue?vue&type=script&lang=js&"
export * from "./AutoMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9351fbc",
  null
  
)

export default component.exports